import { GetServerSideProps } from 'next';

import { logger, PageRendererComponent, prePageCall } from '@marriott/mi-headless-utils';
import { FEATURE_FLAGS, fetchFlag, TARGETS } from '@marriott/mi-feature-flag-utils';
import { constants } from '@marriott/mi-account-components';
import operationSignatures from '../_constants/operationSignatures.json';

const { NEXT_PUBLIC_ENV_KEYS } = constants;

function pageRenderer(props) {
  return <PageRendererComponent {...props} {...{ operationSignatures }} />;
}

//Any product specific page data apart from common data like session, datalayer
//can be returned from this function and the same is passed as props to the page Component
const accountSpecificData = async () => {
  const featureFlagAemltsHost = await fetchFlag(FEATURE_FLAGS.EXPERIENCE_MCOM_ACCOUNT_RENDERER_AEMLTS_HOST, {
    target: TARGETS.APP.ACCOUNT_RENDERER,
  });

  const configuredLtsEnvs = featureFlagAemltsHost?.experience_mcom_account_renderer_aemlts_host;

  const currentEnvironment = process.env.DEPLOYED_ENV_CONFIG ?? '';
  
  const enabledEnvs = configuredLtsEnvs?.split(',').map((env) => env.trim()) ?? [];

  const useAemLtsHost = enabledEnvs.includes('all') || enabledEnvs.includes(currentEnvironment);

  const aemHost = useAemLtsHost ? process.env.NEXT_PUBLIC_AEM_LTS_HOST ?? process.env.NEXT_PUBLIC_AEM_HOST : process.env.NEXT_PUBLIC_AEM_HOST;

  return {
    operationSignatures: [],
    nextPublicEnvKeys: NEXT_PUBLIC_ENV_KEYS,
    aemHost: aemHost ?? null,
  };
};

global.loggerInstance = logger({}) as CallableFunction;

//Make pre page calls like session, datalayer, fetch model.json, producSpecifc data etc
//at server side and pass the data is passed as props to page component.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getServerSideProps: GetServerSideProps<any> = prePageCall(accountSpecificData, true);
export default pageRenderer;
